<template>
    <div>
        <div v-for="langCode in p_supportedLangCodes_ae"
             :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
             class="TQ_inline TQ_margin_16px">

            <div class="TQ_text_20px TQ_text_bold">
                {{format_langCode_fs(langCode)}}
            </div>

            <tq-card max-width="320px" width="100%">
                <tq-wysiwyg-editor
                        :file-name="'qb_gameRules_c_' + langCode + '_'"
                        :pe_choose-file_f="pe_chooseFile_f"
                        :p_value_html="p_qb_gameRules_byLangCode[langCode].w_body_s"
                        :pe_update-value_f="(newValue_html) => {p_qb_gameRules_byLangCode[langCode].w_body_s = newValue_html}"
                        />
            </tq-card>
        </div>
    </div>
</template>

<script>
    import TqWysiwygEditor from "../../../../components/complex/TqWysiwygEditor";
    import {
        validator_enum_array_fb
    } from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {FB_Wysiwyg} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import TqCard from "../../../../components/basic/TqCard";
    import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {helper_getDirectionByLangCode_fe} from "../../../../scripts/S_Helper";
    import {
        validator_enum_fb,
        validator_onjKeysByEnumVal_fb,
        validator_objClass_fb
    } from "../../../../../functions/src/shareCode/Share_S_Validator";
    export default {
        name: "C_Creator_EditQuests_Item_QuestBody_GameRules",
        components: {TqCard, TqWysiwygEditor},
        props: {
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_qb_gameRules_byLangCode:{
                type: Object,
                require: true,
                validator(obj){
                    return validator_objClass_fb(obj, FB_Wysiwyg) && validator_onjKeysByEnumVal_fb(obj, enum_langCodes)
                }
            },
            p_supportedLangCodes_ae :{
                type: Array,
                require: true,
                validator(arr){
                    return validator_enum_array_fb(enum_langCodes ,arr)
                }
            },
            pe_chooseFile_f: {}
        },
        data(){
            return {
                format_langCode_fs: format_langCode_fs,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe
            }
        },

    }
</script>

<style scoped>

</style>